import { useSelector } from 'react-redux'

import { selectUser } from 'store/user'

const useUser = () => useSelector(selectUser)

export default useUser
